import React, { useState } from "react";
import styled from "@emotion/styled";
import { Formik, Form } from "formik";
import { useMutation } from "@tanstack/react-query";
import * as yup from "yup";

import TextField from "@components/text-field";
import Button from "@components/Button";
import { PhoneMask } from "@components/mask-components";
import { postFranchiseMessage, IFranchiseMessage } from "api/messages.request";
import { ModalMessage } from "@components/message-modal";
import DateTimePickerField from "@components/date-time-picker-field";
import { useTranslations } from "next-intl";
import RecaptchaField from "@components/recaptcha-field";
import CheckboxCustom from "@components/checkBox";
import LabelField from "@components/label-field";
import FormWithHostPost from "@components/form-with-host-post";
// import { useModal } from "shared/context/ModalAlert.context";
import FormHotpots from "shared/models/const/form-hotpots";
import { Box } from "@mui/material";

const postData = async (data: IFranchiseMessage) => {
  const response = await postFranchiseMessage(data);
  return response;
};

function ObtainYourFranchise() {
  // const modal = useModal();
  const [key, setKey] = useState(Math.random());

  const [openModal, setOpenModal] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState<boolean>(false);
  const translation = useTranslations("franchise.form");
  const translationAlert = useTranslations("alerts.franchise");
  const translationError = useTranslations("error");

  const validationSchema = yup.object({
    full_name: yup.string().required(translationError("required")),
    phone: yup
      .string()
      .required(translationError("required"))
      .length(10, translationError("phone")),
    email: yup
      .string()
      .email(translationError("email"))
      .required(translationError("required")),
    address: yup.string().required(translationError("required")),
    birthdate: yup.date().required(translationError("required")).nullable(),
    // captcha: yup.string().required(translationError("required")),
    subscribe: yup.boolean().required(translationError("required")),
  });

  const onSubmit = (values: IFormFranchiseValues, e: any) => {
    const data: IFranchiseMessage = {
      address: values.address,
      email: values.email,
      full_name: values.full_name,
      phone: values.phone,
      birthdate: values.birthdate,
      "g-recaptcha-response": values.captcha,
      subscribe: values.subscribe,
    };

    setIsSubscribed(values.subscribe);

    mutate(data, {
      onSuccess: () => {
        e.resetForm();
        e.setFieldValue("birthdate", null);
      },
    });
  };

  const { mutate, isLoading, isError } = useMutation(postData, {
    onSuccess: () => handleModal(),
  });

  const handleModal = () => {
    setOpenModal(!openModal);
  };

  return (
    <Wrapper id={"franchise-content"}>
      {/* <ModalMessage
        title={translationAlert("title")}
        body={
          isSubscribed
            ? translationAlert("bodySuccessSubscribe")
            : translationAlert("body")
        }
        variant={isError ? "error" : undefined}
        open={openModal}
        handleClose={handleModal}
      /> */}
      <div className="container" id="franchise">
        <Title>{translation("title")}</Title>
        <FranchiseForm>
          <FormWithHostPost
            key={key}
            {...FormHotpots.FRANQUICIAS}
            onFormSubmitError={() => {
              // modal.openModal({
              //   title: translationAlert("title"),
              //   body: translationAlert("body"),
              //   variant: "error",
              //   handleClose: () => {},
              // });
              // setKey(Math.random());
            }}
            onFormSubmitSuccess={() => {
              // modal.openModal({
              //   title: translationAlert("title"),
              //   body: translationAlert("body"),
              //   variant: "success",
              //   handleClose: () => {
              //     setOpenModal(false);
              //   },
              // });
              // setKey(Math.random());
            }}
          />
        </FranchiseForm>
      </div>
    </Wrapper>
  );
}

//  <Formik
//    initialValues={initialValues}
//    onSubmit={onSubmit}
//    validationSchema={validationSchema}
//  >
//    {(formikProps) => {
//      return (
//        <FranchiseForm>
//          <InputWrapper>
//            <Input
//              name="full_name"
//              placeholder={translation("fullName") + "*"}
//            />
//          </InputWrapper>
//          <InputWrapper>
//            <Input
//              name="phone"
//              placeholder={translation("phone") + "*"}
//              inputComponent={PhoneMask}
//            />
//          </InputWrapper>
//          <InputWrapper>
//            <Input name="email" placeholder={translation("email") + "*"} />
//          </InputWrapper>
//          <InputWrapper>
//            <Input name="address" placeholder={translation("address") + "*"} />
//          </InputWrapper>
//          <InputWrapper>
//            <DateTimePickerField
//              placeholder={translation("birthDate") + "*"}
//              type="no-custom"
//              name="birthdate"
//            />
//          </InputWrapper>

//          <InputWrapper className="subscriber">
//            <CheckboxCustom
//              onChange={() => {
//                formikProps.setFieldValue(
//                  "subscribe",
//                  !formikProps.values.subscribe
//                );
//              }}
//              checked={formikProps.values.subscribe}
//              name="subscribe"
//              style={{
//                display: "inline-block",
//                justifyContent: "flex-start",
//                padding: "5px 0px 9px 9px",
//              }}
//            />
//            <LabelField
//              label={translation("subscribe")}
//              positionLabel="left"
//            />
//          </InputWrapper>

//          {/* <RecaptchaField formikProps={formikProps} /> */}
//          <SubmitWrapper>
//            <SubmitButton
//              type="submit"
//              disabled={isLoading}
//              loadingMessage={isLoading ? translation("sending") : null}
//              className="enviar-formulario-adquire-franquicia"
//            >
//              {translation("send")}
//            </SubmitButton>
//          </SubmitWrapper>
//        </FranchiseForm>
//      );
//    }}
//  </Formik>;

const Wrapper = styled.section`
  background-color: #f0f0f0;
  border-radius: 200px 200px 0px 0px;
  padding: 93px 0 110px;

  @media screen and (max-width: 991px) {
    border-radius: 150px 150px 0px 0px;
  }

  @media screen and (max-width: 767px) {
    border-radius: 0;
  }
  @media screen and (max-width: 487px) {
    padding: 63px 0 110px;
  }
`;

const Title = styled.h2`
  font-size: 1.75rem;
  font-weight: 500;
  margin-bottom: 60px;
  text-transform: none;
  color: var(--color-text-primary);
`;

const FranchiseForm = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: 750px;
  margin: 0 auto;
   @media screen and (max-width: 767px) {
   padding:1rem;
  }
`;

const SubmitButton = styled(Button)`
  margin: 45px auto 0;
  width: 172px;
`;

const Input = styled(TextField)`
  color: var(--color-brand-blue-main);
  font-size: 1.1rem;
  font-weight: 700;
  border: none;
  outline: none;
  background-color: var(--color-brand-bg-secondary);
  margin-bottom: 5px;

  &::placeholder {
    font-size: inherit;
    font-weight: inherit;
    color: inherit;
  }

  &:hover {
    border: none;
  }
`;

const InputWrapper = styled.div`
  width: 48%;
  margin-bottom: 20px;
  &.subscriber {
    width: 100%;
    display: flex;
    align-items: center;
  }

  @media screen and (max-width: 767px) {
    width: 100%;
  }
`;

const SubmitWrapper = styled.div`
  flex-basis: 100%;
  display: flex;
`;

const initialValues = {
  full_name: "",
  email: "",
  phone: "",
  address: "",
  birthdate: "",
  captcha: "",
  subscribe: true,
};

interface IFormFranchiseValues {
  full_name: string;
  email: string;
  phone: string;
  address: string;
  captcha: string;
  birthdate: any;
  subscribe: boolean;
}

export default ObtainYourFranchise;
